<!-- Max included to fix bug with Selenium testing at Syed's request  #5319 -->
<input class="input is-small" type="date" placeholder="YYYY-MM-DD" [formControl]="datePicker" max="2099-01-31" (change)="onDateChange($event)"> 
<div *ngIf="!isValid" class="invalid-msg">
  The currently entered date is invalid.<br/>
  Use the format YYYY-MM-DD
</div>